import { PartialBrief } from '../../Types/Brief'
import isNewGuest from './isNewGuest'

const isGuestAuthenticated = ({ guest }: PartialBrief): boolean =>
  !isNewGuest(guest) && !!guest.authenticated

export default isGuestAuthenticated
